import { Button, IconButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type InstallationDialogProps = {
  buttonLabel: ReactNode;
  onButtonClick: () => void;
  onCrossClick: () => void;
};

const InstallationDialogContainer = styled.div`
  height: 72px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${cssThemedValue({ light: colors.wolt100, dark: colors.wolt100 })};
  color: ${cssThemedValue({ light: colors.salt100, dark: colors.salt100 })};
  padding: 16px;
  gap: 16px;
`;

const StyledButton = styled(Button)`
  flex-shrink: 0;
`;

const InstallationDialog = ({ buttonLabel, onButtonClick, onCrossClick }: InstallationDialogProps) => {
  return (
    <InstallationDialogContainer>
      <IconButton size="tiny" variant="white" onClick={onCrossClick}>
        <Cross />
      </IconButton>
      <div>
        <FormattedMessage id="pwa.install.description" />
      </div>
      <StyledButton variant="white" size="small" onClick={onButtonClick}>
        {buttonLabel}
      </StyledButton>
    </InstallationDialogContainer>
  );
};

export default InstallationDialog;
